import React from 'react'
import './Content.css'
import photo1 from "../assets/photo1.jpg"
import flower from "../assets/flower.jpg"
import { Link } from "react-router-dom";

const Content = () => {
  const handleevent=()=>{
    console.log("button clicked");
  }
  return (
    <>
    <div className="one">
     
      <div className='digital'>DIGITAL </div>
      
      <div className='designer'> DESIGNER <br/></div>
      
    </div>

    < div className="two" onClick={handleevent}>
      
      
      <div className="projects "><div className="circle"></div>
      <Link to="/projectss">
      <button>projects</button>
      </Link>
      </div>
      
    
 <div className="hello">say hello<div className="circle"></div></div>
      
    
     
    </div>

    <div className="three">
      <img src={photo1} alt=""  />
  
    

    </div>

   <div className="four">
<div className="fourone">
  <a href="https://www.linkedin.com/in/jai-gaigoye/">Linkedin</a>
  <p>email:jai.22210326@viit.ac.in</p>
  <a href="https://github.com/jai2134patil">Github</a>
</div>
<div className="fourtwo">
  <a href="https://drive.google.com/file/d/15cPGydGnHGnc4a8fARRkutFeHyjEEhuE/view?usp=sharing">resume</a>
</div>
   </div>
    </>
  )
}

export default Content
